import React, { ReactNode } from 'react';
import styled from '@emotion/styled';

const WrapperLayout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 2rem;
  padding-bottom: 1rem;
  background-color: #f5f6fb;
`;

interface Props {
  children: ReactNode;
}

export const Wrapper = (props: Props) => {
  return <WrapperLayout>{props.children}</WrapperLayout>;
};

export default Wrapper;
